<section [ngSwitch]="data.formType" class="popup-form-wrapper">
  <ten-traveller-form
    *ngSwitchCase="ProfileDetailsType.Traveller"
    [memberUrl]="memberProfileUrl"
    [pastDataId]="data.dataId"
    [maxAllowedDate]="data?.maxAllowedDate"
    [minAllowedDate]="data?.minAllowedDate"
    [minEligibleAge]="data.minEligibleAge ? data.minEligibleAge : [0, 120]"
    (closed)="closePopUp()"
  ></ten-traveller-form>
  <ten-phone-number-form
    *ngSwitchCase="ProfileDetailsType.PhoneNumber"
    [memberUrl]="memberProfileUrl"
    (closed)="closePopUp()"
    [pastDataId]="data.dataId"
  ></ten-phone-number-form>
  <ten-special-occasion-form
    *ngSwitchCase="ProfileDetailsType.SpecialOccasion"
    [memberUrl]="memberProfileUrl"
    (closed)="closePopUp()"
    [pastDataId]="data.dataId"
  ></ten-special-occasion-form>
  <ten-address-form
    *ngSwitchCase="ProfileDetailsType.Address"
    (closed)="closePopUp()"
    [pastDataId]="data.dataId"
  ></ten-address-form>
  <ten-payment-card-form
    *ngSwitchCase="ProfileDetailsType.PaymentCard"
    (closed)="closePopUp()"
    [pastDataId]="data.dataId"
  ></ten-payment-card-form>
  <ten-delete-popup
    *ngSwitchCase="ProfileDetailsType.DeletePopup"
    (closed)="closePopUp()"
    [data]="data.data"
    [pastDataId]="data.dataId"
  ></ten-delete-popup>
</section>
